/**
 * @generated SignedSource<<4cd4100da337699aac555c2515d1533c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "time",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TesterTimeQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "TesterTimeQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "d29c4f00e7f0f6edd27aa3d1a5e14d6b",
    "id": null,
    "metadata": {},
    "name": "TesterTimeQuery",
    "operationKind": "query",
    "text": "query TesterTimeQuery {\n  time\n}\n"
  }
};
})();

node.hash = "17194200b4239558461ade00ad4edc9d";

module.exports = node;
